<template>
  <div>
    <Head title="Ads" />
          <!-- {{ accounts }} -->
          <h1 class="mb-8 text-3xl font-bold">Ads</h1>
    <div class="flex items-center justify-between mb-6">
         <search-filter v-model="form.search"  class="mr-4 w-full max-w-md" @reset="reset">
      </search-filter>
    
    </div>




    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">Ads Name</th>
          <th class="pb-4 pt-6 px-6">Adset Name</th>
          <th class="pb-4 pt-6 px-6">Account Name</th>
          <th class="pb-4 pt-6 px-6">Campaign Name</th>
          <th class="pb-4 pt-6 px-6"  @click="toggleSort('status')">Status
            <span v-if="sortColumn === 'status'">
              <span v-if=" this.form.sortOrder === 'ACTIVE'">↑</span>
              <span v-else>↓</span>
            </span>
          </th>
          <th class="pb-4 pt-6 px-6"  @click="toggleSort('time')">Created<br> time
            <span v-if="sortColumnTime === 'time'">
              <span v-if=" this.form.sortTime === 'desc'">↑</span>
              <span v-else>↓</span>
            </span></th>
          <th class="pb-4 pt-6 px-6">Impressions</th>
          <th class="pb-4 pt-6 px-6">Clicks</th>
          <th class="pb-4 pt-6 px-6">Spend</th>
          <th class="pb-4 pt-6 px-6">Cpc</th>
          <th class="pb-4 pt-6 px-6">Cpm</th>
          <th class="pb-4 pt-6 px-6">Reach</th>
          <th class="pb-4 pt-6 px-6">Cpp</th>
          <th class="pb-4 pt-6 px-6">Website Roas</th>
          <th class="pb-4 pt-6 px-6">Purchase Roas</th>
        </tr>
        <tr v-for="(ads) in ads.data" :key="ads.ads_id" class="hover:bg-gray-100 focus-within:bg-gray-100">
        <td class="border-t">
            <span class="flex items-center px-6 py-4"  :title="ads.name" tabindex="-1">
                {{ truncatedName(ads.name) }}

            </span>
        </td>
        <td class="border-t">
          <a 
            v-if="ads.adset && ads.adset[0] && ads.adset[0].name" 
            :href="`/adset?adset_id=${ads.adset[0].adset_id}`" 
            class="flex items-center px-6 py-4 max-w-full bg-blue-300 overflow-hidden text-ellipsis whitespace-nowrap"
            :title="ads.adset[0].name"
            tabindex="-1"
          >
            {{ truncatedName(ads.adset[0].name) }}
          </a>
        <span 
          v-else 
          class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-400"
        >
           N/A
        </span>
      </td>
        <td class="border-t">
            <span class="flex items-center px-6 py-4" :title="ads.adset[0].campaign[0].account[0].name"  tabindex="-1">
              {{ truncatedName(ads.adset[0].campaign[0].account[0].name) }}
            </span>
        </td>
        <td class="border-t">
          <a v-if="ads.adset[0] && ads.adset[0].campaign[0] && ads.adset[0].campaign[0].campaign_id" 
            :href="`/campaign?campaign_id=${ads.adset[0].campaign[0].campaign_id}`" 
            class="flex items-center px-6 py-4 max-w-full bg-blue-300 overflow-hidden text-ellipsis whitespace-nowrap"
            :title="ads.adset[0].campaign[0].name"
            tabindex="-1"
          >
            {{ truncatedName(ads.adset[0].campaign[0].name) }}
          </a>
        <span v-else  class="flex items-center px-6 py-4 max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-gray-400">
           N/A
        </span>
      </td>
        <!-- <td class="border-t">
            <span class="flex items-center px-6 py-4"  :title="ads.adset[0].campaign[0].name" tabindex="-1">
                {{ truncatedName(ads.adset[0].campaign[0].name) }}
            </span>
        </td> -->
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.status">{{ ads.status }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.created_time">{{ ads.created_time }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.impressions">{{ ads.impressions }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.clicks">{{ ads.clicks }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.spend">{{ ads.spend }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.cpc">{{ ads.cpc }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.cpm">{{ ads.cpm }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.reach">{{ ads.reach }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.cpp">{{ ads.cpp }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.website_purchase_roas">{{ ads.website_purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
        <td class="w-px border-t">
            <span class="flex items-center px-4" tabindex="-1">
                <span v-if="ads.purchase_roas">{{ ads.purchase_roas }}</span>
                <span v-else>N/A</span>
            </span>
        </td>
          <!-- <td class="w-px border-t">
              <span class="flex items-center px-4"  tabindex="-1">  {{ ads.date_stop }}</span>
          </td> -->
          <!-- Action Icon -->
          <!-- <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/post/${content.cntnt_id}/edit`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
          </td> -->
      </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="ads.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/Search'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    ads: Object,
    adset: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        account: this.filters.account,
        sortOrder: this.filters.sortOrder,
        sortTime: this.filters.sortTime,
      },
      isDisabled: false,
      isLoading: false,
      sortColumn: 'status', 
      sortColumnTime: 'time', 
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('ads', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    toggleSort(column) {
        // If the same column is clicked again, toggle the order
        if (column == 'status' &&  this.sortColumn === 'status') {
          this.form.sortOrder = this.form.sortOrder === 'PAUSED' ? 'ACTIVE' : 'PAUSED';
        }
        if (column == 'time' && this.sortColumnTime === 'time') {
          this.form.sortTime = this.form.sortTime === 'asc' ? 'desc' : 'asc';
        } 
    },
    truncatedName(text) {
      const maxLength = 20;
      const name = text || '';
      return name.length > maxLength ? name.substring(0, maxLength) + '...' : name;
    },
  },
} 
</script>
<style scoped>
.bg-blue-300 {
  color: rgb(115, 115, 206);
}
.bg-blue-300:hover{
  color: blue;
}
</style>